import React from 'react';
import { getMarkerEnd } from 'react-flow-renderer';
import '../workflowEditor.css';
import AddIcon from './EdgeIcons';

const edgeSplitPosition = 25;
const edgeJoinPosition = 40;
const foreignObjectHeight = 24;

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  label,
  arrowHeadType,
  markerEndId,
  data,
}) {
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  let edgePath = `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;
  let foreignObjectWidth = targetX - sourceX;
  let foreignObjectLeft = sourceX;
  let foreignObjectTop = targetY - foreignObjectHeight / 2;
  let secondForeignObject = <></>;
  if (data.abSplitEdge) {
    edgePath = `M ${sourceX} ${sourceY} L ${sourceX + edgeSplitPosition} ${sourceY} L ${
      sourceX + edgeSplitPosition
    } ${targetY} L ${targetX} ${targetY}`;
    foreignObjectWidth -= edgeSplitPosition;
    foreignObjectLeft += edgeSplitPosition;
  } else if (data.abMergeEdge) {
    edgePath = `M ${sourceX} ${sourceY} L ${sourceX + edgeJoinPosition} ${sourceY} L ${
      sourceX + edgeJoinPosition
    } ${targetY} L ${targetX} ${targetY}`;
    foreignObjectWidth = edgeJoinPosition;
    foreignObjectLeft = sourceX;
    foreignObjectTop = sourceY - foreignObjectHeight / 2;
    if (data.mergeEdgesCanAdd) {
      // Add the second add node for after the merge
      secondForeignObject = (
        <foreignObject
          width={foreignObjectWidth}
          height={foreignObjectHeight}
          x={targetX - foreignObjectWidth - edgeJoinPosition / 2}
          y={targetY - foreignObjectHeight / 2}
        >
          <AddIcon
            canAdd={data.canAdd}
            id={id}
            callback={data.addNewNodeCallback}
            alt="Add new workflow step after A/B conditions"
            isPostMerge
          />
        </foreignObject>
      );
    }
  }
  const caption = label ? label + ' ' : '';

  return (
    <>
      <path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} />
      <foreignObject width={foreignObjectWidth} height={foreignObjectHeight} x={foreignObjectLeft} y={foreignObjectTop}>
        <AddIcon
          caption={caption}
          canAdd={data.canAdd}
          id={id}
          callback={data.addNewNodeCallback}
          alt="Add new workflow step"
        />
      </foreignObject>

      {secondForeignObject}
    </>
  );
}
